const popmechanicPatched = new WeakSet();

function injectPopmechanicFocusStyles() {
    if (document.getElementById('popmechanic-a11y-focus-styles')) return;
    const style = document.createElement('style');
    style.id = 'popmechanic-a11y-focus-styles';
    style.textContent = `
        [id^="popmechanic-form-"] .popmechanic-close:focus-visible,
        [id^="popmechanic-form-"] .popmechanic-submit:focus-visible,
        [id^="popmechanic-form-"] .popmechanic-input:focus-visible,
        [id^="popmechanic-form-"] .popmechanic-policy-link:focus-visible {
            outline: 2px solid #3D3D3D !important;
            outline-offset: 2px !important;
        }
    `;
    document.head.appendChild(style);
}

function isFocusableVisible(el) {
    if (el.hasAttribute('disabled')) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    return el.offsetParent !== null;
}

function patchPopmechanicDialog(modal) {
    if (popmechanicPatched.has(modal)) return;
    popmechanicPatched.add(modal);

    const activeScreen = modal.querySelector('.popmechanic-screen_active') || modal.querySelector('.popmechanic-screen');
    const title = activeScreen?.querySelector('.popmechanic-title')?.textContent?.trim();
    modal.setAttribute('aria-label', title || 'Promotional dialog');

    const closeBtn = modal.querySelector('.popmechanic-close');
    if (closeBtn) {
        if (closeBtn.tagName !== 'BUTTON') {
            closeBtn.setAttribute('role', 'button');
            if (!closeBtn.hasAttribute('tabindex')) closeBtn.setAttribute('tabindex', '0');
            closeBtn.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    closeBtn.click();
                }
            });
        }
        if (!closeBtn.getAttribute('aria-label')) closeBtn.setAttribute('aria-label', 'Close');
        if (modal.firstChild !== closeBtn) modal.prepend(closeBtn);
    }

    const lastFocused = document.activeElement instanceof HTMLElement ? document.activeElement : null;

    const getCandidates = () => Array.from(modal.querySelectorAll(
        'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )).filter(isFocusableVisible);

    for (const el of getCandidates()) {
        el.focus({ preventScroll: true });
        if (document.activeElement === el) break;
    }

    const keydownHandler = (e) => {
        if (e.key === 'Escape') {
            const closeBtn = modal.querySelector('.popmechanic-close');
            if (closeBtn) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                closeBtn.click();
            }
            return;
        }
        if (e.key !== 'Tab') return;
        const f = getCandidates();
        if (!f.length) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const direction = e.shiftKey ? -1 : 1;
        let idx = f.indexOf(document.activeElement);
        if (idx === -1) idx = direction === 1 ? -1 : 0;
        for (let i = 0; i < f.length; i++) {
            idx = (idx + direction + f.length) % f.length;
            f[idx].focus();
            if (document.activeElement === f[idx]) return;
        }
    };
    document.addEventListener('keydown', keydownHandler, true);

    const wrapper = modal.closest('.popmechanic-js-animation-wrapper');
    let closed = false;

    const isClosed = () => {
        if (!document.contains(modal)) return true;
        if (wrapper && document.contains(wrapper)) {
            const style = window.getComputedStyle(wrapper);
            if (style.display === 'none' || style.visibility === 'hidden') return true;
        }
        return false;
    };

    const cleanup = () => {
        if (closed) return;
        closed = true;
        document.removeEventListener('keydown', keydownHandler, true);
        closeObserver.disconnect();
        popmechanicPatched.delete(modal);
        if (lastFocused && document.contains(lastFocused)) {
            lastFocused.focus();
        }
    };

    const closeObserver = new MutationObserver(() => {
        if (isClosed()) cleanup();
    });
    if (wrapper) {
        closeObserver.observe(wrapper, { attributes: true, attributeFilter: ['style'] });
    }
    if (modal.parentNode) {
        closeObserver.observe(modal.parentNode, { childList: true });
    }
}

injectPopmechanicFocusStyles();

new MutationObserver(() => {
    const popmechanicImage = document.querySelector('popmechanic-image')
    if (popmechanicImage) {
        popmechanicImage.removeAttribute('role')
        popmechanicImage.removeAttribute('aria-label')
    }
    const cards = document.querySelectorAll('.popmechanic-item-card');
    if (cards && cards.length > 0) {
        cards.forEach(el => {
            if (el.getAttribute('aria-hidden') === 'true') {
                el.querySelectorAll('a').forEach((child) => {
                    child.setAttribute('tabindex', '-1');
                });
            }
        });
    }
    document
        .querySelectorAll('[role="dialog"][aria-modal="true"].popmechanic-js-form')
        .forEach(patchPopmechanicDialog);
}).observe(document.body, { childList: true, subtree: true });

document.querySelectorAll('img').forEach(fixAlt);

new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            if (node.tagName === 'IMG') fixAlt(node);
            node.querySelectorAll('img').forEach(fixAlt);
        });
    });
}).observe(document.body, { childList: true, subtree: true });